import type { UserModel } from 'shared/domain/user/types/model';
import { useEntityCollectionInitializer } from '../../entityCollection';
import type { StoreData } from '../../types';
import { useProjectUsersStore } from '../store';
import type { ProjectUsersActions } from '../types';

/** Loads the users of the selected project and keeps them current. */
export function useProjectUsersInitializer(): void {
  useEntityCollectionInitializer(useProjectUsersStore.use.actions());
}

/** Users of the selected project, unfiltered, with their loading state. */
export function useProjectUsers(): StoreData<UserModel> {
  return useProjectUsersStore.use.data();
}

/** Project users actions (stable references). */
export function useProjectUsersActions(): ProjectUsersActions {
  return useProjectUsersStore.use.actions();
}
